import { cx } from "../../lib/cx";

/** Urbanist stack. Applied on each design-system root so the app font stays. */
export const dsFont = "font-ds";

/** Card surface: glass, blur 26 / saturate 1.1, radius 26, card shadow. No border. */
export const dsCard = cx(
  dsFont,
  "rounded-ds-card bg-ds-glass px-[22px] py-[18px] shadow-ds-card backdrop-blur-ds backdrop-saturate-[1.1]",
);

export const dsFocus =
  "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[3px] focus-visible:outline-ds-ink";

/** Undo the Preflight-compat button padding and keep 400/600 only. */
export const dsControl = cx(
  dsFont,
  dsFocus,
  "m-0 cursor-pointer border-0 motion-reduce:transition-none",
);

export function toneBg(tone: "teal" | "amber" | "coral"): string {
  if (tone === "coral") return "bg-ds-coral";
  if (tone === "amber") return "bg-ds-amber";
  return "bg-ds-teal";
}
